export class BookingDiaryDayCtrl implements ng.IComponentController {
  event      : any;
  eventBox   : number;
  eventMargin: number;

  constructor (
    private $rootScope: ng.IRootScopeService,
    private $scope    : ng.IScope,
    private $window   : ng.IWindowService
  ) {}

  $onDestroy () {
    this.$rootScope.$broadcast('pg-tooltip-hide');
  }

  $onInit () {
    this.eventBox    = ( ( ( this.$window.innerWidth * 0.095 ) / 5 ) * 0.75 );
    this.eventMargin = ( ( ( this.$window.innerWidth * 0.095 ) / 5 ) / 4 );
  }

  isVehicleAvailable ( event = this.event ) : boolean {
    return !!event.available_loan_vehicles;
  }

  viewDay ( event : any ) : void {
    this.$scope.$emit('viewDay', event, true);
  }
}
